<template>
    <div>
        <!-- 主页面 -->
        <main-reconciliation v-if="mainShow" @mainClick="handleClick"></main-reconciliation>
        <detail-reconciliation v-if="detailShow" :mainInfo="mainInfo" :factoryList="factoryList" :accList="accList" @detailClick="handleDetailClick"></detail-reconciliation>
    </div>
</template>
<script>
import MainReconciliation from './components/accountComponents/MainReconciliation.vue';
import DetailReconciliation from './components/accountComponents/DetailReconciliation.vue';
export default {
    components:{
        MainReconciliation,
        DetailReconciliation
    },
    data(){
        return{
            mainShow:true,
            detailShow:false,
            mainInfo:{},
            factoryList:[],
            accList:[],
        }
    },
    methods:{
        handleClick(data,factoryList,accList){
            this.mainShow = false;
            this.detailShow = true;
            this.mainInfo = data;
            this.factoryList = factoryList;
            this.accList = accList;
            console.log(accList,'accList')
        },
        handleDetailClick(){
            this.mainShow = true;
            this.detailShow = false;
        }
    }
}
</script>